import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FONT } from "@styles/common";

export const CustomTitle = styled(Text)`
    ${FONT("pretendard", 24, 700)};
`;

export const CustomInputTitle = styled(Text)`
    ${FONT("pretendard", 16, 500, 1.5)};
`;
